import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'

import { DemoTradingAccountNavigation } from '../Navigation/DemoTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountPendingOrdersTable from './TradingAccountPendingOrdersTable'

import '../TradingAccount.scss'

interface Props {
  data: {
    id: string
    name: string
  }
}

const DemoTradingAccountPendingOrdersPage: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const fetchPendingOrders = useCallback(
    () => tradingAccountsApiClient.getDemoTradingAccountPendingOrders(data.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data.id]
  )
  const { data: pendingOrders = [], isLoading } = useFetchOne(fetchPendingOrders)

  return (
    <React.Fragment>
      <DemoTradingAccountNavigation data={data} isEdit={false} tab={TradingAccountTab.Orders} />
      <Loading isLoading={isLoading}>
        <TradingAccountPendingOrdersTable pendingOrders={pendingOrders} />
      </Loading>
    </React.Fragment>
  )
}

export default DemoTradingAccountPendingOrdersPage
